// Utility functions used across components

// URL validation functions
export const isValidImageUrl = (url) => {
    // Basic URL validation
    return url && (
      url.match(/\.(jpeg|jpg|gif|png)$/) !== null ||
      url.startsWith('data:image/') ||
      url.startsWith('/uploads/')
    );
  };
  
  export const isValidVideoUrl = (url) => {
    // Check for common video platforms
    return url && (
      url.includes('youtube.com') || 
      url.includes('youtu.be') || 
      url.includes('vimeo.com') || 
      url.includes('dailymotion.com')
    );
  };
  
  // Video helper functions
  export const getVideoId = (url) => {
    // YouTube URL patterns
    const youtubeRegex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(youtubeRegex);
    return match ? match[1] : null;
  };
  
  export const getVideoThumbnail = (url) => {
    // YouTube URL patterns
    const youtubeRegex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(youtubeRegex);
    if (match) {
      // Use YouTube's thumbnail API
      return `https://img.youtube.com/vi/${match[1]}/mqdefault.jpg`;
    }
    // Default thumbnail for non-YouTube videos or if ID extraction fails
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='70' viewBox='0 0 120 70'%3E%3Crect width='120' height='70' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='30%25' font-family='Arial' font-size='10' text-anchor='middle' dominant-baseline='middle' fill='%23999'%3EVideo%3C/text%3E%3Ctext x='50%25' y='70%25' font-family='Arial' font-size='8' text-anchor='middle' dominant-baseline='middle' fill='%23999'%3E(Önizleme yok)%3C/text%3E%3C/svg%3E";
  };

  export const stripHtml = (html) => {
    if (!html) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  };